import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { BaseFillCollect } from '@/app/components/icons/BaseFillCollect';
import { BaseLineCollect } from '@/app/components/icons/BaseLineCollect';
import type { ButtonProps } from '@/app/components/ui/button';
import type { CommunityEnum, UpdateInteractionStatusFn } from '@/app/types';
import { cn, formatCount } from '@/app/utils';

interface CollectBtnProps {
  id: string;
  itemCollect: boolean;
  itemCollectCount: number;
  tabType: CommunityEnum;
  className?: string;
  traceId?: string;
  handleCollect?: UpdateInteractionStatusFn;
  handleUnCollect?: UpdateInteractionStatusFn;
  iconClassName?: string;
  numClassName?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  hideEmptyCollectCount?: boolean;
  hideCount?: boolean;
}

export const CollectBtn: FC<CollectBtnProps> = ({
  id,
  itemCollect,
  tabType,
  itemCollectCount,
  className,
  traceId,
  handleCollect,
  handleUnCollect,
  iconClassName,
  numClassName,
  hideEmptyCollectCount = false,
  hideCount = false,
}) => {
  const [isActive, setIsActive] = useState(itemCollect);
  const [activeCount, setActiveCount] = useState(itemCollectCount);

  useEffect(() => {
    setIsActive(itemCollect);
    setActiveCount(itemCollectCount);
  }, [itemCollect, itemCollectCount]);

  return (
    <div
      className={cn('flex items-center justify-center gap-1', className)}
      onClick={(e) => {
        e.stopPropagation();
        if (isActive) {
          handleUnCollect?.({ id, obj_type: tabType, traceId: traceId || '' });
          setIsActive(false);
          setActiveCount(activeCount - 1);
        } else {
          handleCollect?.({ id, obj_type: tabType, traceId: traceId || '' });
          setIsActive(true);
          setActiveCount(activeCount + 1);
        }
      }}
    >
      {isActive ? (
        <BaseFillCollect className={cn('size-4', iconClassName)} />
      ) : (
        <BaseLineCollect className={cn('size-4', iconClassName)} />
      )}
      {!(hideEmptyCollectCount && !activeCount) && !hideCount && (
        <div className={cn('min-w-[1ch] text-sm', numClassName)}>{formatCount(activeCount || 0)}</div>
      )}
    </div>
  );
};
